// components/Error.js
import Alert from "react-bootstrap/Alert"
import Button from "react-bootstrap/Button"
import "../styles/BreikkiAlert.css"
import { useTranslation } from "react-i18next"

const BreikkiAlert = ({ message, onRetry, isError }) => {

  const { t } = useTranslation()

  return (
    <Alert
      variant={isError ? "danger" : undefined}
      className="BREIKKI-alert-container d-flex justify-content-between align-items-center"
    >
      <span className="BREIKKI-alert-message">{message}</span>
      {onRetry && (
        <Button
          variant="outline-light"
          size="sm"
          className="BREIKKI-alert-retry-btn"
          onClick={onRetry}
        >
          {t("breikki_alert_retry_label")}
        </Button>
      )}
    </Alert>
  )
}

export default BreikkiAlert
